<div class="route-stage" [@routeAnimations]="outlet.activatedRouteData?.['animation']">
  <router-outlet #outlet="outlet"></router-outlet>
</div>


<app-toast-container></app-toast-container>
